import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Label,
  InfoButton,
  Toggle,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEvent } from "react"
import { useCallback } from "react"

import styles from "./Display.module.scss"
import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import { useInputPropsForValue } from "src/hooks"

const polyglotPrefix = "pages.settings.display.show_difference."
const id = "show-difference-toggle"

interface Props {
  updatedAt?: string;
  updateDeviceSettings: (settings: Partial<DeviceSettings>) => void;
}

export function ShowDifference(props: Props) {
  const {
    updatedAt,
    updateDeviceSettings,
  } = props

  const polyglot = usePolyglot()
  const { currentDeviceSettings } = useFollowedUsers()
  const currentShowDifference = currentDeviceSettings.show_delta

  const adapter = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => e.target.checked,
    [],
  )

  const onValueChange = useCallback(
    (showDelta: DeviceSettings["show_delta"]) => {
      updateDeviceSettings({
        show_delta: showDelta,
      })
    },
    [updateDeviceSettings],
  )

  const {
    value,
    onChange,
  } = useInputPropsForValue({
    value: currentShowDifference,
    onChange: onValueChange,
    adapter,
    updatedAt,
  })

  return (
    <div className={styles.toggleRow}>
      <Label
        htmlFor={id}
        id="show-difference-label"
      >
        {polyglot.t(`${polyglotPrefix}label`)}
        <InfoButton title={polyglot.t(`${polyglotPrefix}title`)}>
          <div>
            {polyglot.t(`${polyglotPrefix}description_one`)}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_two`)}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_three`)}
          </div>
        </InfoButton>
      </Label>
      <Toggle
        id={id}
        checked={!!value}
        onChange={onChange}
      />
    </div>
  )
}
